<template>
  <div :class="$style.wrapper">
    <div :class="$style.image" :style="{ backgroundImage: `url(${image})` }"></div>
    <div :class="$style.title">Задание «{{title}}»</div>
    <div :class="$style.score">{{text}}</div>
    <Button wide @click="$emit('click')" :class="$style.button">Пройти заново</Button>
  </div>
</template>
<script>
import plural from '@/utils/plural'

import Button from '@/components/@ui/Button/Button.vue'

export default {
  name: 'TaskCard',
  props: {
    score: Number,
    maxPoints: Number,
    title: String,
    image: String,
  },
  components: { Button },
  computed: {
    text() {
      const { maxPoints, score } = this

      return `${score} из ${maxPoints} ${plural(maxPoints, 'балл', 'балла', 'баллов')}`
    },
  },
}
</script>
<style lang="scss" module>
@import './TaskCard.scss';
</style>
